// CardSection.js
import React from 'react';

class CouponCodeSection extends React.Component {
    constructor(props) {
        super(props);
        this.handleReady = this.handleReady.bind(this);
    }

    handleReady() {
        console.log('card element ready');
    }

    render() {
        const { error, disabled, updating } = this.props;

        const applyCoupon = () => {
            const val = this.myTextInput.value;
            this.props.applyCoupon(val);
        };

        return (
            <div className="row">
                <div className="col-12">
                    <label>Coupon Code</label>
                </div>
                <div className="col-md-9">
                    <div className={`form-group form-group-xl  ${error && 'is-invalid'}`}>
                        <div className="input-wrapper">
                            <input
                                id={`coupon-code`}
                                ref={ref => { this.myTextInput = ref; }}
                                className="form-control"
                                disabled={this.props.couponCode}
                                label={`Coupon Code`}
                                placeholder="eg: POWER10"
                            />
                            <div className="error-indicator" />
                        </div>
                        {error && <div className="invalid-feedback">{error}</div>}
                    </div>
                </div>
                <div className="col-md-3">
                    <button
                        onClick={applyCoupon}
                        className="btn btn-xl btn-primary text-uppercase font-weight-normal w-100"
                        type="button"
                        disabled={updating || disabled || this.props.submitting}
                    >Apply
                    </button>

                </div>
            </div>

        );
    }
}

export default CouponCodeSection;
